const $ = require('lib/jquery')
const Marionette = require('lib/marionette')
const ViewerModel = require('./viewer_model')
const getChecklist = require('module/checklist/get_checklist')
const TrackProFeatures = require('module/track_pro_features/track_pro_features')
const Beacon = require('module/beacon/beacon')
const Zendesk = require('module/zendesk/zendesk')
const log = require('log').create('viewer', '#900')
require('plugin/cookie')
require('jquery-add-prefixed-class')

const ViewerController = Marionette.MnObject.extend({

    initialize(options) {
        this.model = new ViewerModel()
        this.listenTo(this.model, 'change:logged_in', this.setLoginState)
        this.listenTo(this.model, 'change:flags.premium', this.setChecklist)
    },

    initializeModel(attrs) {
        attrs.logged_in = !!attrs.user_name

        // todo: remove after zendesk migration
        if (attrs.beacon_id) {
            Beacon.install(attrs.beacon_id)
        }

        if (attrs.show_zendesk_widget) {
            Zendesk.install()
        }

        this.model.set(this.model.parse(attrs))

        this.track_pro_features = new TrackProFeatures({ user: this.model })
    },

    setLoginState() {
        this.logged_in = this.is('logged_in')
        log(`${(this.logged_in ? '' : 'not ')}logged in`)
        $.html.addPrefixedClass('logged', this.logged_in ? 'in' : 'out')

        if (this.logged_in) {
            // set is_user cookie shared with all subdomains (blog.about.me)
            const g = require('globals')
            $.cookie('is_user', this.logged_in, {
                expires: 365,
                path: '/',
                domain: `.${g.DOMAIN_NAME}`,
            })

            if (Zendesk.isInstalled()) {
                Zendesk.api('webWidget', 'prefill', {
                    name: {
                        value: this.get('display_name'),
                        readOnly: false,
                    },
                    email: {
                        value: this.get('email_address'),
                        readOnly: true,
                    },
                })
            }
        }
    },

    setChecklist() {
        log('setChecklist')
        this.model.checklist = getChecklist(this.model)
    },

})

// shortcuts for direct access to Viewer.model methods
const proxy_methods = [
    'get',
    'escape',
    'set',
    'unset',
    'is',
    'isNot',
    'isUser',
    'hasApp',
    'hasFeature',
    'toJSON',
    'serialize',
    'hasAction',
    'trackAction',
]

proxy_methods.forEach((method) => {
    ViewerController.prototype[method] = function proxy() {
        return this.model[method].apply(this.model, arguments)
    }
})

module.exports = ViewerController
